/** The quiz activity types a gameshow round may ask. */
export const GAMESHOW_QUIZ_ACTIVITY_TYPES = [
  'multi_choice_single_response',
  'multi_choice_multi_response',
  'phrase_matching',
  'drag_pairing',
  'drag_ordering',
] as const;

export const GAMESHOW_ROUND_COUNT = 5;
export const GAMESHOW_CORRECT_DELTA = 10;
